'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageIcon = _react2.default.createElement(
  'svg',
  { width: '81', height: '76', viewBox: '647 0 81 76', xmlns: 'http://www.w3.org/2000/svg' },
  _react2.default.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    _react2.default.createElement('path', { d: 'M647 76h81V0h-81v76zm2.5-2.5h76v-71h-76v71z', fill: '#FFF' }),
    _react2.default.createElement('path', { fill: '#FFF', d: 'M648.3 12.7h78.4V10h-78.4M652 7.6h2.6V5H652M657 7.6h2.7V5H657M662.2 7.6h2.5V5h-2.5' }),
    _react2.default.createElement('path', { fill: '#FFF', d: 'M667.3 11.4h2.5v-10h-2.5M672.3 7.6H723V5h-50.7' }),
    _react2.default.createElement(
      'g',
      { transform: 'translate(647)' },
      _react2.default.createElement('path', { d: 'M39.2 35.5c-1.4 0-2.5 1-2.5 2.5v10c0 1.5 1 2.7 2.5 2.7h2.6c1.4 0 2.5-1.2 2.5-2.6V38c0-1.4-1-2.5-2.5-2.5h-2.6zm2.6 17.7h-2.6c-2.8 0-5-2.3-5-5V38c0-2.8 2.2-5 5-5h2.6c2.8 0 5 2.2 5 5v10c0 3-2.2 5.2-5 5.2z', fill: '#FFF' }),
      _react2.default.createElement('path', { fill: '#FFF', d: 'M29 53.2h2.6V33H29' }),
      _react2.default.createElement('path', { fill: '#FFF', d: 'M30.4 45.6h-8l-2-2V33h2.4v9.5l.5.6h7M58.2 53.2h2.6V33h-2.6' }),
      _react2.default.createElement('path', { fill: '#FFF', d: 'M59.5 45.6h-8l-2-2V33h2.4v9.5l.4.6h7' }),
      _react2.default.createElement('path', { d: 'M7.6 68.4h65.8V17.7H7.6v50.7zM5 71h71V15H5V71z', fill: '#FFF' }),
      _react2.default.createElement('path', { fill: '#FFF', d: 'M12.7 25.3h55.6v-2.5H12.7M12.7 63.3h55.6v-2.5H12.7M12.7 44.3h2.5v-2.5h-2.5M65.8 44.3h2.5v-2.5h-2.5' })
    )
  )
);

var ghost = _react2.default.createElement(
  'svg',
  { width: '81', height: '103', viewBox: '541 619 81 103', xmlns: 'http://www.w3.org/2000/svg', className: 'notfound-ghost' },
  _react2.default.createElement(
    'g',
    { fill: 'none', fillRule: 'evenodd' },
    _react2.default.createElement('path', { d: 'M594.33 720l-6.4-6.4-6.43 6.4-6.42-6.4-6.4 6.4-6.43-6.4-6.42 6.4-6.4-6.4L543 720v-60.68c0-21.16 17.24-38.32 38.5-38.32s38.5 17.16 38.5 38.32V720l-6.42-6.4-6.4 6.4-6.43-6.4-6.42 6.4z', stroke: '#222829', strokeWidth: '3', strokeLinecap: 'round', strokeLinejoin: 'round' }),
    _react2.default.createElement('path', { d: 'M567.06 691h28.88', stroke: '#222829', strokeWidth: '3' }),
    _react2.default.createElement('path', { d: 'M576.7 664.1c0 5.3-4.32 9.6-9.64 9.6-5.3 0-9.62-4.3-9.62-9.6 0-5.28 4.3-9.57 9.62-9.57 5.32 0 9.63 4.3 9.63 9.58z', stroke: '#222829', strokeWidth: '3', strokeLinecap: 'round', strokeLinejoin: 'round' }),
    _react2.default.createElement('path', { d: 'M567.67 664h3.2', stroke: '#FF6138', strokeWidth: '5' }),
    _react2.default.createElement('path', { d: 'M605.56 664.1c0 5.3-4.3 9.6-9.62 9.6-5.32 0-9.63-4.3-9.63-9.6 0-5.28 4.33-9.57 9.65-9.57 5.3 0 9.62 4.3 9.62 9.58z', stroke: '#222829', strokeWidth: '3', strokeLinecap: 'round', strokeLinejoin: 'round' }),
    _react2.default.createElement('path', { d: 'M596.54 664h3.2', stroke: '#FF6138', strokeWidth: '5' })
  )
);

var NotFound = function NotFound(_ref) {
  var route = _ref.route;

  return _react2.default.createElement(
    'section',
    { className: 'page ' + route },
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'hero' },
        _react2.default.createElement(
          'div',
          null,
          pageIcon
        ),
        _react2.default.createElement(
          'h1',
          null,
          'Oops, Page Not Found'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'page-container notfound' },
        _react2.default.createElement(
          'div',
          { className: 'flex-hold' },
          _react2.default.createElement(
            'div',
            { className: 'flex-content-half notfound-align-right' },
            ghost,
            _react2.default.createElement(
              'h1',
              { className: 'notfound-oops' },
              'Oops, Sorry'
            ),
            _react2.default.createElement(
              'div',
              { className: 'notfound-text' },
              'We can\'t find the page',
              _react2.default.createElement('br', null),
              'you\'re looking for'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'vert-rule' },
            '\xA0'
          ),
          _react2.default.createElement(
            'div',
            { className: 'flex-content-half notfound-suggestions' },
            _react2.default.createElement(
              'div',
              { className: 'notfound-text' },
              'How about one of these pages?'
            ),
            _react2.default.createElement(
              'div',
              { className: 'notfound-links' },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/subsector/banking' },
                'Learn About Careers'
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/list/employers-who-are-hiring' },
                'Who is Hiring'
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/list/where-to-get-training' },
                'Get Training'
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/landing/about-financial-services' },
                'About Financial Services'
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/advising' },
                'Advising'
              )
            )
          )
        )
      )
    )
  );
};

exports.default = NotFound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/NotFound/index.js
// module id = 1099
// module chunks = 0